import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { faceIdVarMi, faceIdAcikMi, faceIdAc, faceIdNedenYok } from '../../utils/faceId';
import { muvekkilAPI, notificationAPI } from '../../api/api';

/** Teshis satiri oturum turu basina bir kez gonderilsin. */
const taniGonderildi = new Set();
import './FaceIdTeklifi.css';

/*
  FACE ID TEKLIFI
  ---------------
  NEDEN VAR: Face ID daha once giris basarili olur olmaz, hicbir sey
  sorulmadan ARKA PLANDA aciliyordu. Kullanici dashboard'a gecerken
  ekrana birdenbire bir Face ID penceresi dusuyor, ne icin soruldugu
  yazmiyordu; cogu zaman fark edilmeden kapatiliyor ve ozellik hic
  acilmiyordu. Sonucta uygulama her acilista TC ve sifre soruyordu.

  SIMDI: giris tamamlandiktan sonra ne oldugu yazili bir kart cikiyor
  ve Face ID penceresi ancak kullanici "Aç" dedikten sonra aciliyor.

  NE ZAMAN CIKAR: yalnizca uygulamada, cihazda Face ID tanimliysa,
  daha once acilmamissa ve kullanici son 7 gun icinde "Şimdi değil"
  dememisse.

  JETON NEREDE: sifre HICBIR YERDE saklanmiyor; yalnizca oturum jetonu
  telefonun korumali alaninda duruyor (bkz. utils/faceId.js).
*/

const ERTELEME_ANAHTARI = 'faceIdTeklifiErtelendi';
const ERTELEME_GUN = 7;

const ertelenmisMi = () => {
  try {
    const t = parseInt(localStorage.getItem(ERTELEME_ANAHTARI) || '0', 10);
    if (!t) return false;
    return (Date.now() - t) < ERTELEME_GUN * 24 * 60 * 60 * 1000;
  } catch (e) {
    return false;
  }
};

/**
 * Hangi oturum acik? Muvekkil jetonu varsa muvekkil, yoksa personel.
 * Ikisi de yoksa null doner ve teklif hic gosterilmez.
 */
const acikOturum = () => {
  try {
    if (localStorage.getItem('muvekkilToken')) {
      return { tur: 'muvekkil', jeton: localStorage.getItem('muvekkilToken') };
    }
    if (localStorage.getItem('token')) {
      return { tur: 'personel', jeton: localStorage.getItem('token') };
    }
  } catch (e) { /* yoksay */ }
  return null;
};

const FaceIdTeklifi = () => {
  const [acik, setAcik] = useState(false);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState('');

  /*
    NE ZAMAN BAKILIYOR: sayfa her degistiginde.
    Onceden yalnizca uygulama ACILDIGINDA bir kez bakiliyordu. O anda
    kullanici henuz giris ekranindaydi, oturum yoktu ve teklif
    gosterilmiyordu; giris yapildiktan sonra da bir daha bakilmadigi
    icin Face ID teklifi HIC cikmiyordu.
  */
  const konum = useLocation();

  useEffect(() => {
    if (acik) return undefined;
    let iptal = false;

    (async () => {
      const oturum = acikOturum();
      if (!oturum) return;

      const acikMi = faceIdAcikMi();
      const ertelendi = ertelenmisMi();
      const varMi = (!acikMi && !ertelendi) ? await faceIdVarMi() : false;

      /* TESHIS: kart cikmadiginda sebebi tahmin etmek yerine telefon
         sunucu kaydina yaziyor. Oturum turu basina uygulama acilisinda
         bir kez gonderiliyor. */
      if (!taniGonderildi.has(oturum.tur)) {
        taniGonderildi.add(oturum.tur);
        const metin = `acik=${acikMi} ertelendi=${ertelendi} kullanilabilir=${varMi} neden=${faceIdNedenYok()}`;
        (oturum.tur === 'muvekkil' ? muvekkilAPI : notificationAPI).tani('faceid', metin);
      }

      if (!iptal && varMi && !acikMi && !ertelendi) setAcik(true);
    })();

    return () => { iptal = true; };
  }, [konum.pathname, acik]);

  const ac = async () => {
    setHata('');
    setCalisiyor(true);
    const oturum = acikOturum();
    if (!oturum) { setCalisiyor(false); setAcik(false); return; }

    const oldu = await faceIdAc(oturum.jeton, oturum.tur);
    setCalisiyor(false);
    if (oldu) {
      setAcik(false);
      return;
    }
    // Kullanici vazgectiyse ya da dogrulama basarisizsa kart kapanmiyor;
    // tekrar deneyebilsin diye kisa bir aciklama yaziliyor.
    setHata('Açılamadı. Tekrar deneyebilir ya da daha sonra açabilirsiniz.');
  };

  const sonra = () => {
    try { localStorage.setItem(ERTELEME_ANAHTARI, String(Date.now())); } catch (e) { /* yoksay */ }
    setAcik(false);
  };

  if (!acik) return null;

  return (
    <div className="fit-katman" role="dialog" aria-modal="true" aria-labelledby="fit-baslik">
      <div className="fit-kutu">
        <div className="fit-simge" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor"
               strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 8V6a2 2 0 0 1 2-2h2" />
            <path d="M16 4h2a2 2 0 0 1 2 2v2" />
            <path d="M20 16v2a2 2 0 0 1-2 2h-2" />
            <path d="M8 20H6a2 2 0 0 1-2-2v-2" />
            <path d="M9 10v1M15 10v1" />
            <path d="M12 10v3.5a.5.5 0 0 1-.5.5H11" />
            <path d="M9 16c.9.7 1.9 1 3 1s2.1-.3 3-1" />
          </svg>
        </div>

        <h2 id="fit-baslik">Face ID ile giriş açılsın mı?</h2>

        <p>
          Bir dahaki açışınızda TC ve şifre yazmadan, yüzünüzle giriş
          yaparsınız. Şifreniz telefonda saklanmaz.
        </p>

        {hata && <p className="fit-hata">{hata}</p>}

        <button type="button" className="fit-birincil" onClick={ac} disabled={calisiyor}>
          {calisiyor ? 'Doğrulanıyor…' : 'Aç'}
        </button>
        <button type="button" className="fit-ikincil" onClick={sonra} disabled={calisiyor}>
          Şimdi değil
        </button>
      </div>
    </div>
  );
};

export default FaceIdTeklifi;
